<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Painel de Manutenção - Vending Machine {{$route.params.id}}</h4>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData">
            <el-table-column label="Opção" property="options" min-width="340"></el-table-column>
            <el-table-column label="Ações" width="140">
              <div class="td-actions" slot-scope="props">
                <a
                  class="btn btn-danger btn-link btn-xs"
                  @click="openDoor(props.$index, props.row)"
                >
                  <i class="fa fa-unlock"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Configurações</h4>
        </div>
        <div>
          <fg-input name="sound" label="Som">
          <div>
            <l-switch v-model="model.sound"></l-switch>
          </div>
          </fg-input>

          <fg-input v-if="model.sound" name="volume" label="Volume">
            <el-slider :class="color(model.volume)" v-model="model.volume"/>
          </fg-input>

          <fg-input name="repositor_pwd" type="number" label="Senha de Reposição" v-model="model.repositor_pwd"></fg-input>
         
          <fg-input label="Validade da senha de reposição">
            <el-date-picker
              v-model="model.expiration_repositor_pwd"
              type="datetime"
              format="dd/MM/yyyy"
              placeholder="Selecione a data"
            ></el-date-picker>
          </fg-input> 

          <fg-input name="video" label="Vídeo">
            <div>
              <l-switch v-model="model.video"></l-switch>
            </div>
          </fg-input>
          <fg-input name="out_service" label="Máquina fora de serviço" v-if="showOut">
            <div>
              <l-switch v-model="model.out_of_service" @input="outService()"></l-switch>
            </div>
          </fg-input>

        </div>

      </card>
<!--   Matriz de molas     -->
      <card>
        <div v-loading="!showMatriz"
          element-loading-text="Carregando..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)" >
          <div v-if="Number(model.coil_per_shelf) > 0">
            <div v-for="i in numberShelf" :key='i.id'>
              <p style="margin-bottom: -20px; margin-top: 10px">Prateleira  {{String.fromCharCode(i + 64)}}</p>
              
              <div class="row " style="">
                <fg-input
                  v-for="n in Number(model.coil_per_shelf)"
                  :key="n.id"
                  name="coil"
                  style="padding-left: 15px; margin-bottom: -10px"
                  label="">
                    <br>


                  <l-button 
                            v-bind:class="{ checkColor }"
                            style="width: 40px; height: 40px; " 
                            ref="btn"
                            @click="setCoil(n + Number(model.coil_per_shelf)*(i-1))">{{n}}</l-button>&nbsp;

                </fg-input>
              </div>
            </div>
            <div v-if="numberShelf > 0" style="height: 25px"></div>
              <!-- <l-button wide type="primary" round @click="addShelf()" >
                <span class="btn-label">
                  <i class="fa fa-plus"></i>
                </span>
                  &nbsp;&nbsp;Adicionar Prateleira
              </l-button>  -->

              <!-- <l-button wide type="danger" round 
                        @click="removeShelf()" v-if="numberShelf !== 0 && crud === 'Criar'"
                        style="margin-left: 20px">
                <span class="btn-label">
                  <i class="fa fa-minus"></i>
                </span>
                  &nbsp;&nbsp;Remover Prateleira
              </l-button>

              <l-button wide type="danger" round 
                        @click="removeShelf()" v-if="crud === 'Editar' && numberShelf > originalShelf"
                        style="margin-left: 20px">
                <span class="btn-label">
                  <i class="fa fa-minus"></i>
                </span>
                  &nbsp;&nbsp;Remover Prateleira
              </l-button> -->
              
          </div>
        </div>
      </card>

      <card>
        <div>
          <el-button type="primary" :loading="btnLoading" 
            @click.prevent="save">Salvar</el-button>
          <!-- <button type="submit" :loading="btnLoading"
            @click.prevent="save" class="btn btn-fill btn-info btn-wd">Salvar</button> -->
        </div>
    </card>
    </div>
  </div>
</template>
<script>
import { Table,
  TableColumn,
  Select,
  Option,
  DatePicker,
  Button,
  Slider, } from "element-ui";
import swal from "sweetalert2";
import { Switch as LSwitch } from "src/components/index";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Slider.name]: Slider,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    LSwitch
  },
  data() {
    return {
      model: {
        sound: false,
        volume: 30,
        repositor_pwd: "",
        video: false,
        out_of_service: false,
        expiration_repositor_pwd: '',
        perCoil: [],
        coil_per_shelf: '',
        shelves_quantity: 7,
      },
      coil_per_shelf: '',
      perCoil: [],
      numberShelf: 0,
      showOut: false,
      showMatriz: false,
      result: [],
      btnLoading: false,
      }
  },
  computed: {
    tableData() {
      var dados = [
          {options: 'Porta'}
      ] 
      return dados;
    },

    users() {
      return this.$store.state.users.users;
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
    products() { 
      const p = this.$store.state.products.products;
      const withVariants = p.map(v => {
        const variants = this.variants.filter(e => e.product == v.id);
        return { ...v, variants };
      });
      return withVariants;
    },
    variants() {
      return this.$store.state.products.variants.variants;
    },
    shelves() {
      return this.$store.state.shelves.shelves;
    },
    coils() {
      return this.$store.state.coils.coils;
    },
    productVariants() {
      return product => {
        const p = this.products.find(e => e.id == product) || {};
        const v = p.variants;
        return v;
      };
    },
    shelvesByMachine() {
      const shelves = [...this.$store.state.shelves.shelves];
      const byMachine = shelves.filter(e => e.vm === Number(this.$route.params.id));
      console.log({ byMachine });
      return byMachine;
    },
    coilsByShelf() {
      const coils = [...this.$store.state.stock.coils];
      const shelves = [...this.shelvesByMachine]
      const dateConverted = coils.map(v => {
        let expiration_date = v.expiration_date;
        if (v.expiration_date) {
          const d = v.expiration_date.split("-").join("/");
          expiration_date = d;
        }
        let letter, vm_position
        if(v.vm_position){
          letter = v.vm_position.charAt(0)
          vm_position = v.vm_position.substr(1)
        }
        return { ...v, expiration_date, letter, vm_position };
      });
      const byShelf = shelves.map(v => {
        const c = dateConverted.filter(e => e.shelf === v.id);
        
        return [...c];
      });
      if (this.crud === 'Editar') {
        for (let index = 0; index < byShelf.length; index++) {
          byShelf[index] = byShelf[index].sort((a,b) => (Number(a.vm_position) > Number(b.vm_position)) ? 1 : ((Number(b.vm_position) > Number(a.vm_position)) ? -1 : 0))
        }
        this.arrange(byShelf)
      }
      console.log('byshlef', byShelf)
      this.showMatriz = true      
      return byShelf;
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
    var ciaID = localStorage.getItem('imachCiaID')
    this.ciaID = ciaID
    if (ciaID) { 
      this.model.company = ciaID
    } else {
      ciaID = ''
    }
    this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID}).then(() => {
      if (this.$route.params.id) {
        this.model = this.$store.state.machines.machines.find(
          e => e.id == this.$route.params.id
        );
      }
      this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID}).then(() => {
        this.$store.dispatch("products/variants/listSort",{sort: '?company=' + ciaID}).then(() => {
          this.$store.dispatch("shelves/listSort",{sort: '?company=' + ciaID}).then(() => {
            if (this.$route.params.id) {
              this.$store.dispatch("stock/listSort", {sort: '?shelf__vm=' + this.$route.params.id + '&ordering=id' + '&page_size=600'}).then(() => {
              });
              setTimeout(() => {
                this.coilsByShelf          
              }, 1800);
            }
          });
        });
      });
    });
    this.ifFlag()

    this.$watch('numberShelf', () => {
      this.checkColor()
    })
  },
  methods: {
    openDoor () {
      swal.fire({
        title: "Atenção!",
        text: `Você está prestes a abrir a porta da máquina. Após a confirmação, a maquina irá soltar um "beep" por 2 segundos
        e outro novamente após 25 segundos. A porta só estará destrancada durante os "beep".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, abra!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          var machineId = this.$route.params.id
          this.$store.dispatch('machines/open', {url: machineId + "/open_door/", item: {
                "topic": "door",
                "action": "open"
            }} )
          let timerInterval
          swal.fire({
            title: 'Abrindo porta!',
            html: 'Próximo "beep" será em <b></b> segundos.',
            timer: 25000,
            timerProgressBar: true,
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              swal.showLoading()
              timerInterval = setInterval(() => {
                console.log('content', swal.getContent())
                console.log('timerLeft', swal.getTimerLeft())
                swal.getContent().querySelector('b')
                  .textContent = (swal.getTimerLeft()/1000).toFixed(0)
              }, 1000)
            },
            willClose: () => {
              clearInterval(timerInterval)
            }
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Comando de abrir porta não enviado.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    color(value) {
      if (value <= 75) {
        return "slider-success";
      } else {
        return "slider-danger";
      }
    },
  //  Matriz das molas


    checkColor () {
      setTimeout(() => {
        for (let index = 0; index < this.perCoil.length; index++) {
          if (this.perCoil[index]) {
            this.$refs.btn[index].type = 'success'
          } else {
            this.$refs.btn[index].type = 'default'
          }        
        }
      }, 10);
    },
    setCoil (n) {
      this.perCoil[n-1] = !this.perCoil[n-1]
      if (this.perCoil[n-1]) {
        this.$refs.btn[n-1].type = 'success'
      } else {
        this.$refs.btn[n-1].type = 'default'
      }
      console.log('setcoil', this.perCoil)
    },

    addShelf () {
      this.numberShelf += 1 
      for (let index = 0 + Number(this.model.coil_per_shelf)*(this.numberShelf-1); index < this.model.coil_per_shelf*this.numberShelf; index++) {
        this.perCoil[index] = true
      }
      console.log('add', this.perCoil)
    },
    removeShelf () {
      this.numberShelf -= 1
      for (let index = (Number(this.model.coil_per_shelf)*this.numberShelf+1); index < this.perCoil.length; index++) {
        this.perCoil.splice(index)
      }
      this.perCoil.splice(-1,1)
      console.log('remove', this.perCoil)
    },
    arrange (dados) {
      this.originalShelf = dados.length      
      for (let index = 0; index < dados.length; index++) {
        this.addShelf()
      }
      var x = 0
      // this.numberShelf = dados.length
      for (let index = 0; index < dados.length; index++) {
        for (let i = 0; i < dados[index].length; i++) {
          this.perCoil[x] =  dados[index][i].active
          x += 1
        }        
      }
    },

    final () {
      var x
        for (let i = 0; i < this.perCoil.length; i++) {
          for (let index = 0; index <= this.numberShelf; index++) {
            if (Number(this.model.coil_per_shelf)*index <= i){
              x = index
            } 
          this.result[i] = {value: this.perCoil[i],
                            shelf: x,
                            coil: i-x*Number(this.model.coil_per_shelf)}
                                       
          }
      }
      console.log('final', this.result)
    },



    ifFlag() {
      // console.log('asd', this.$store.state.general.flag)
      this.$store.state.general.flag.filter(el =>{
        if( el.vm == this.$route.params.id) {
          if (el.feature == 'V02') {
            if (el.active) {
              this.showOut = true
            }
          } 
        }
      })
    },
    save () {
      this.btnLoading = true
      this.model.id = this.$route.params.id
      this.model.expiration_repositor_pwd = new Date(
          this.model.expiration_repositor_pwd
        ).toISOString().split('T')[0];
      this.final()
      this.$store.dispatch("machines/updateConfig", { item: this.model }).then(resp => {
        console.log('resp', resp)
        if (resp.id) {
          let payload = { data: this.result, id: resp.id }
          this.$store.dispatch('machines/create_shelf', payload).then(()=>{
            this.btnLoading = false
            this.notifySuccess();
            this.$router.push(`/app/machines/machines`);
          })
        } else {
          this.notifyError()
        }
      }); 
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifySuccessOUT() {
      this.$notify({
        message: "Sucesso</br>Máquina fora de serviço!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifySuccessIN() {
      this.$notify({
        message: "Sucesso</br>Máquina de volta ao serviço!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    outService () {
      if (this.model.out_of_service) {
        swal.fire({
          title: "Atenção!",
          text: `A máquina ficará fora serviço.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim, desativar máquina!",
          cancelButtonText: "Cancelar",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('machines/outService', {id: this.$route.params.id, item: {
                  "out_of_service": true
              }} ).then(data =>{
                if (data.status == '200') {
                  this.notifySuccessOUT()
                } else {
                  this.notifyError()
                }
                console.log('data', data)
              }) 
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Comando de desativar máquina não foi enviado.`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
            this.model.out_of_service = false
          }
        });
      } else {
        swal.fire({
          title: "Atenção!",
          text: `A máquina voltará ao serviço.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim, ativar máquina!",
          cancelButtonText: "Cancelar",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('machines/outService', {id: this.$route.params.id, item: {
                  "out_of_service": false
              }} ).then(data =>{
                if (data.status == '200') {
                  this.notifySuccessIN()
                } else {
                  this.notifyError()
                }
              }) 
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Comando de ativar máquina não foi enviado.`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
            this.model.out_of_service = true
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
